import React from "react";
import usePersistedState from "../../hooks/usePersistedState";
import debounce from "../../util/debounce";
import { useStore } from "../../store/store";

function useLocationSelector(submitPressed: boolean, editQuote: boolean) {
  const addToQuote = useStore((state) => state.addToQuote);

  const [location, setLocation] = usePersistedState(
    "location",
    "",
    submitPressed,
    editQuote
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setLocation(value);
    debounce(value, addToQuote, "location", 400);
  };

  return {
    handleChange,
    location,
  };
}

export default useLocationSelector;
